/* ========================================================================
   Link blocks
 ========================================================================== */

app.linkBlocks = (function () {
  'use strict';

  function init() {
    const sections = document.querySelectorAll('.js-linkBlocks');
    if (sections.length === 0) return;

    sections.forEach((section) => {
      const viewport = section.querySelector('.linkBlocks__viewport');
      const items = section.querySelectorAll('.linkBlocks__item');

      const prevBtn = section.querySelector('.embla__button--prev');
      const nextBtn = section.querySelector('.embla__button--next');

      //
      // Init slider and buttons
      //

      const slider = new EmblaCarousel(viewport, {
        inViewThreshold: 0.1,
        align: 'start',
        containScroll: 'trimSnaps',
      });

      app.sliders.initPrevNextButtons(prevBtn, nextBtn, slider);

      //
      // Event listeners
      //

      slider.on('init', function (event) {
        app.sliders.disablePrevNextButtons(prevBtn, nextBtn, slider);
        viewport.classList.add('is-initialized');
      });

      slider.on('select', function (event) {
        app.sliders.disablePrevNextButtons(prevBtn, nextBtn, slider);
      });

      items.forEach((item, index) => {
        item.addEventListener('focus', (event) => {
          item.scrollIntoView();
        });

        item.addEventListener(
          'touchstart',
          (event) => {
            item.classList.add('is-touch');
          },
          { passive: true }
        );

        item.addEventListener('mouseleave', (event) => {
          item.classList.remove('is-touch');
        });

        item.addEventListener('click', (event) => {
          if (item.classList.contains('is-link')) return;
          event.preventDefault();

          if (slider.clickAllowed()) {
            showLightbox(item);
          }
        });
      });
    });
  }

  function showLightbox(item) {
    if (item.classList.contains('is-video')) {
      app.general.openVideoLightbox(item.href);
    } else {
      var lightbox = new BasicLightbox('<img src="' + item.href + '" alt="" />');

      lightbox.show();
    }
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
